import { Theme } from 'morpheus-ui';
import { tv } from 'tailwind-variants';

const borderWidthKeys = Object.keys(Theme.borderWidth);
export const ContentWrapper = tv(
  {
    base: 'text-mono-color-black group w-full flex flex-row justify-between gap-sm bg-color-lightest rounded-md shadow-level-2 p-4 cursor-pointer overflow-visible',
    variants: {
      color: {
        'embriologia-superior':
          'hover:bg-disciplina-embriologia-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'farmacologia-superior':
          'hover:bg-disciplina-farmacologia-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'fisiologia-superior':
          'hover:bg-disciplina-fisiologia-humana-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'genetica-superior':
          'hover:bg-disciplina-genetica-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'anatomia-superior':
          'hover:bg-disciplina-anatomia-humana-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'bioquimica-superior':
          'hover:bg-disciplina-bioquimica-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'histologia-superior':
          'hover:bg-disciplina-histologia-humana-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'histologia-humana-superior':
          'hover:bg-disciplina-histologia-humana-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'imunologia-superior':
          'hover:bg-disciplina-imunologia-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'parasitologia-superior':
          'hover:bg-disciplina-parasitologia-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'patologia-superior':
          'hover:bg-disciplina-patologia-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'microbiologia-superior':
          'hover:bg-disciplina-microbiologia-superior transition ease-in-out delay-100 hover:text-card-color-default',
        default: '',
      },
      selected: {
        true: 'border-hairline border-brand-color-primary-pure',
      },
    },
  },
  {
    twMergeConfig: {
      theme: {
        borderWidth: borderWidthKeys,
      },
    },
  }
);

export const IconDone = tv({
  base: 'text-xxl filled',
  variants: {
    type: {
      done: 'text-feedback-color-success-pure',
      unseen: 'text-mono-color-medium',
      incorrect: 'text-feedback-color-error-pure',
    },
  },
});

export const IconFav = tv({
  base: 'p-0 filled',
  variants: {
    type: {
      favorite: 'text-feedback-color-warning-pure',
      notFavorite: 'text-mono-color-medium',
    },
  },
});

export const SubjectTag = tv({
  base: 'flex max-w-[60%] flex-row items-center gap-sm px-2 text-mono-color-white',
  variants: {
    color: {
      'embriologia-superior':
        'group-hover:text-disciplina-embriologia-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
      'farmacologia-superior':
        'group-hover:text-disciplina-farmacologia-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
      'fisiologia-superior':
        'group-hover:text-disciplina-fisiologia-humana-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
      'genetica-superior':
        'group-hover:text-disciplina-genetica-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
      'anatomia-superior':
        'group-hover:text-disciplina-anatomia-humana-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
      'bioquimica-superior':
        'group-hover:text-disciplina-bioquimica-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
      'histologia-superior':
        'group-hover:text-disciplina-histologia-humana-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
      'histologia-humana-superior':
        'group-hover:text-disciplina-histologia-humana-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
      'imunologia-superior':
        'group-hover:text-disciplina-imunologia-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
      'parasitologia-superior':
        'group-hover:text-disciplina-parasitologia-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
      'patologia-superior':
        'group-hover:text-disciplina-patologia-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
      'microbiologia-superior':
        'group-hover:text-disciplina-microbiologia-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
      default: '',
    },
  },
});
